<template>
  <div class="rounded my-auto mb-3">
    <div :class="[isFocusedDay ? 'text-indigo-700' : 'text-gray-700']">
      {{ taskTime }}
    </div>
    <div
      :class="[
        'block',
        'text-xs',
        'text-gray-900',
        'hover:text-gray-900',
        'hover:bg-gray-100',
        'focus:outline-none',
        'bg-white',
        'rounded',
        'shadow',
        'my-2',
        'overflow-hidden',
        $route.query.taskId === task.uuid ? 'border border-blue-900' : '',
      ]"
      @click="$emit('edit:task', task)"
    >
      <div
        v-if="contact || contactRequest"
        class="p-2 font-medium text-xs border-b bg-gray-200"
        :class="[$route.query.taskId === task.uuid ? 'bg-gray-600 text-white' : '']"
      >
        <span v-if="contact" v-text="contact.fullName"></span>
        <span v-else v-text="contactRequest.full_name"></span>
      </div>
      <TaskCardProject v-if="project" :project="project" />
      <div class="p-2 space-y-2" :class="[$route.query.taskId === task.uuid ? 'bg-gray-200' : '']">
        <p class="font-medium">
          {{ task.title }}
        </p>
        <div v-if="task.content" class="leading-4 h-12 overflow-hidden text-gray-600">
          {{ task.content }}
        </div>
      </div>
      <div
        v-if="!contact"
        class="p-2"
        :class="[$route.query.taskId === task.uuid ? 'bg-gray-200' : '']"
      >
        <BaseBadge
          :silver="task.status === 'draft'"
          :custom="task.status === 'pending'"
          :orange="task.status === 'in progress'"
          :red="task.status === 'in review'"
          :green="task.status === 'completed'"
          :class="[task.status === 'pending' ? 'bg-blue-600 text-white' : '']"
        >
          {{ task.status }}
        </BaseBadge>
      </div>
      <div
        v-if="assignee"
        class="p-2 flex items-center"
        :class="[$route.query.taskId === task.uuid ? 'bg-gray-200' : '']"
      >
        <svg
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          viewBox="0 0 24 24"
          stroke="currentColor"
          class="w-4 h-4 inline-flex text-gray-700 mr-2"
        >
          <path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
        {{ assignee.fullName }}
      </div>
    </div>
  </div>
</template>

<script>
import TaskCardProject from './TaskCardProject.vue';

export default {
  components: {
    TaskCardProject,
  },
  props: {
    task: {
      type: Object,
      required: true,
    },
    isFocusedDay: Boolean,
  },
  computed: {
    project() {
      if (!this.task?.project) {
        return null;
      }

      return this.$store.state.entities.projects.byId[this.task?.project];
    },
    contactRequest() {
      if (!this.task.contactRequest) {
        return null;
      }

      return this.$store.state.entities.contactRequests.byId[this.task.contactRequest];
    },
    contact() {
      if (!this.task.contactId) {
        return null;
      }

      return this.$store.state.entities.contacts.byId[this.task.contactId];
    },
    assignee() {
      if (!this.task.userAssignedId) {
        return null;
      }

      return this.$store.state.entities.users.byId[this.task.userAssignedId];
    },
    taskTime() {
      if (!this.task.dueAt) return '';
      const [, time = ''] = this.task.dueAt.split(' ');
      return time;
    },
  },
};
</script>
